import { render, staticRenderFns } from "./PageEventABCBookCompleted.vue?vue&type=template&id=f65bb3a0&scoped=true&"
import script from "./PageEventABCBookCompleted.vue?vue&type=script&lang=js&"
export * from "./PageEventABCBookCompleted.vue?vue&type=script&lang=js&"
import style0 from "./PageEventABCBookCompleted.vue?vue&type=style&index=0&id=f65bb3a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65bb3a0",
  null
  
)

export default component.exports